import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PS } from '../theme';
import { Icon } from '../lib/icons';
import { Wordmark } from '../lib/ui';

const TABS = [
  { id: 'home', label: 'หน้าหลัก', icon: Icon.home, path: '/app' },
  { id: 'map', label: 'ค้นหาแชร์', icon: Icon.map, path: '/app/discover' },
  { id: 'create', label: 'ตั้งวง', icon: Icon.plus, path: '/app/create' },
  { id: 'chat', label: 'แชท', icon: Icon.chat, path: '/app/chat' },
  { id: 'me', label: 'ฉัน', icon: Icon.user, path: '/app/me' },
];

const activeFor = (pathname, p) => (p === '/app' ? pathname === '/app' : pathname.startsWith(p));

function TabBar() {
  const nav = useNavigate();
  const { pathname } = useLocation();
  return (
    <div className="ps-tabbar" style={{
      background: PS.surface2, borderTop: `1px solid ${PS.line}`,
      paddingTop: 9, paddingBottom: 'max(8px, env(safe-area-inset-bottom))',
      display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', flexShrink: 0,
    }}>
      {TABS.map((t) => {
        const IcoC = t.icon;
        const isA = activeFor(pathname, t.path);
        const isCreate = t.id === 'create';
        return (
          <button key={t.id} data-testid={`tab-${t.id}`} onClick={() => nav(t.path)}
            style={{
              border: 'none', background: 'transparent', display: 'flex', flexDirection: 'column',
              alignItems: 'center', gap: 3, color: isA ? PS.ink : PS.textMuted, cursor: 'pointer',
              padding: 0, fontFamily: PS.fontUI,
            }}>
            {isCreate ? (
              <div style={{ width: 36, height: 36, borderRadius: 12, background: PS.ink, color: PS.page, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <IcoC size={20} stroke={PS.page} />
              </div>
            ) : <IcoC size={22} stroke={isA ? PS.ink : PS.textMuted} />}
            <div style={{ fontSize: 10, fontWeight: isA ? 600 : 500 }}>{t.label}</div>
          </button>
        );
      })}
    </div>
  );
}

/** Desktop-only left rail (shown via .ps-sidebar at >=1024px). */
function DesktopSidebar() {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const navItems = TABS.filter((t) => t.id !== 'create');
  return (
    <aside className="ps-sidebar" data-testid="desktop-sidebar">
      <div style={{ padding: '0 8px 22px' }}><Wordmark size={22} /></div>
      <nav style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {navItems.map((t) => {
          const IcoC = t.icon;
          const isA = activeFor(pathname, t.path);
          return (
            <button key={t.id} data-testid={`desktop-nav-${t.id}`} onClick={() => nav(t.path)} className="ps-press"
              style={{
                display: 'flex', alignItems: 'center', gap: 12, width: '100%', textAlign: 'left',
                border: 'none', borderRadius: 12, padding: '12px 14px', fontFamily: PS.fontUI,
                fontSize: 14.5, fontWeight: isA ? 600 : 500, cursor: 'pointer',
                background: isA ? 'oklch(0.62 0.12 38 / 0.10)' : 'transparent',
                color: isA ? PS.terracotta : PS.text,
              }}>
              <IcoC size={20} stroke={isA ? PS.terracotta : PS.text} />
              {t.label}
            </button>
          );
        })}
      </nav>
      <button data-testid="desktop-nav-create" onClick={() => nav('/app/create')} className="ps-press"
        style={{
          marginTop: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 9,
          background: PS.ink, color: PS.page, border: 'none', borderRadius: 999,
          padding: '13px 18px', fontSize: 14.5, fontWeight: 600, fontFamily: PS.fontUI, cursor: 'pointer',
        }}>
        <Icon.plus size={18} stroke={PS.page} /> ตั้งวงแชร์
      </button>
      <div style={{ marginTop: 'auto', display: 'flex', gap: 8, alignItems: 'center', padding: '0 8px', fontSize: 11, color: PS.textDim, lineHeight: 1.5 }}>
        <Icon.shield size={14} stroke={PS.forest} />
        คนกลางผู้เก็บหลักฐาน · ถูกต้องตาม พ.ร.บ. เล่นแชร์ 2534
      </div>
    </aside>
  );
}

/** Full-screen app column; full width on phones, sidebar + framed column on desktop. */
export default function MemberLayout({ children, tab = true, bg = PS.page }) {
  return (
    <div className="ps-shell">
      <DesktopSidebar />
      <div className="ps-col" style={{ background: bg, fontFamily: PS.fontUI, color: PS.text }}>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          {children}
        </div>
        {tab && <TabBar />}
      </div>
    </div>
  );
}

export { TabBar };
